import { GenIcon } from '../helpers/IconBase.es.js';

const HighlightBackgroundFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M1.94415 6.00573C2.54711 4.07621 4.0497 2.55978 5.97363 1.93916C9.74306 0.723219 13.7938 0.687181 17.5843 1.83581L17.969 1.95236C19.9848 2.56319 21.5674 4.13223 22.1957 6.14261C23.4021 10.0033 23.3977 14.1543 22.1913 18.015C21.5665 20.0141 19.9986 21.5873 17.9994 22.212C14.1246 23.4229 9.97248 23.4229 6.09761 22.212C4.09848 21.5873 2.5329 20.0217 1.90818 18.0226C0.697272 14.1477 0.697272 9.99566 1.90818 6.12078L1.94415 6.00573Z",
          fill: "none"
        }
      }
    ]
  })(props);
};

export { HighlightBackgroundFilled };
